import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { UserPreferencesProvider } from "./contexts/UserPreferencesContext";
import NavigationHeader from "./components/NavigationHeader";
import UserPanel from "./components/UserPanel";
import AdminPanel from "./components/AdminPanel";
import AuthRedirect from "./components/AuthRedirect";

// Protected Route wrapper component
const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const auth = useAuth();

  // Jeśli trwa ładowanie, pokaż loader
  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  // Jeśli nie jest zalogowany, przekieruj do strony głównej
  if (!auth.isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Sprawdź uprawnienia admina
  if (requireAdmin) {
    const groups = auth.user?.profile["cognito:groups"] || [];
    const isAdmin = groups.includes("Admins");
    if (!isAdmin) {
      console.warn("Unauthorized attempt to access admin panel");
      return <Navigate to="/user-panel" replace />;
    }
  }

  return children;
};

function App() {
  const auth = useAuth();

  // Sprawdź uprawnienia admina tylko gdy użytkownik jest zalogowany
  const isAdmin =
    auth.isAuthenticated &&
    (auth.user?.profile["cognito:groups"] || []).includes("Admins");

  return (
    <UserPreferencesProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        <NavigationHeader auth={auth} isAdmin={isAdmin} />
        <main className="container mx-auto px-4">
          <Routes>
            <Route
              path="/"
              element={
                auth.isAuthenticated ? (
                  <Navigate
                    to={isAdmin ? "/admin-panel" : "/user-panel"}
                    replace
                  />
                ) : (
                  <div className="text-center p-8">
                    <h1 className="text-2xl font-bold mb-4">
                      Welcome to AgenciAI
                    </h1>
                    <p>Please sign in to continue.</p>
                  </div>
                )
              }
            />
            <Route
              path="/user-panel"
              element={
                <ProtectedRoute>
                  <UserPanel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin-panel"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
            <Route path="/auth-callback" element={<AuthRedirect />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </UserPreferencesProvider>
  );
}

export default App;
